export const franchiseKey = {
  FRANCHISE_NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  MOBILE: 'mobile',
  FACILITY_TYPE: 'type',
  LEASED: 'isLeased',
  NO_EMP: 'numberOfEmployee',
  FLOOR_SPACE: 'floorSpace',
  ADDRESS: 'address',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
  PINCODE: 'pincode',
  GST: 'taxIdentityNumber',
  BIO_PROTECTED: 'isBiodiversityProtectedArea',
  BIO_ADJACENT_FACILITY: 'isAdjacentToProtectedArea',
  WATER_SCARED: 'isWaterScarceArea',
  SEVERE_IMPACT: 'hasSevereBiodiversityImpact',
  IMPACTED_AREA: 'areaImpacted',
  LESSOR_NAME: 'assetLessorName',
  MOBILE_NO: 'assetLessorMobile',
  RENTED_FROM: 'assetLessorRentedFrom',
  RENTED_TO: 'assetLessorRentedTo',
  rating: 'rating',
  resType: 'restaurantType',
  occupancyRate: 'occupancyRate',
  totalNoOfRooms: 'totalNoOfRooms',
  averageRoomSize: 'averageRoomSize',
  averageMealsPerYear: 'averageMealsPerYear',
  coordinates: 'coordinates',
  TOTAL_EMISSION: 'totalEmissions',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const franchiseLabel = {
  FRANCHISE_NAME: 'Franchise Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  FACILITY_TYPE: 'Facility Type',
  EMAIL: 'Email ID',
  LEASED: 'Leased',
  NO_EMP: 'Number of Employees',
  FLOOR_SPACE: 'Floor Space',
  ADDRESS: 'Address',
  CITY: 'City',
  STATE: 'State',
  COUNTRY: 'Country',
  PINCODE: 'Pincode',
  GST: 'GST Number',
  BIO_PROTECTED: 'Is The Facility On A Biodiversity Protected Area ?',
  LIST_BIO_PROTECTED: 'Biodiversity Protected Area',
  MOBILE: 'Mobile Number',
  BIO_ADJACENT_FACILITY:
    'Is The Facility Adjacent To A Biodiversity Protected Area ?',
  WATER_SCARED: 'Is The Facility Located Is Water Scarce Area ?',
  SEVERE_IMPACT: 'Does It Have A Severe Impact On Biodiversity ?',
  IMPACTED_AREA: 'Area Impacted',
  LESSOR_NAME: 'Asset Lessor Name',
  MOBILE_NO: 'Asset Mobile Number',
  RENTED_FROM: 'Rented From',
  RENTED_TO: 'Rented To',
  rating: 'Rating',
  resType: 'Restaurant Type',
  occupancyRate: 'Occupancy Rate',
  totalNoOfRooms: 'Total Number of Rooms',
  averageRoomSize: 'Average Room Size',
  averageMealsPerYear: 'Average Meals',
  STATUS_COMMENTS: 'Status & Comments',
  TOTAL_EMISSION: 'Total Emissions',
  STATUS: 'Status',
  COMMENT: 'Comment'
};

export const colSpan = 6;
